module.exports = __webpack_public_path__ + "img/header-illustration.45885460.png";